import {REQUEST_QUOTES, RECEIVE_QUOTES, REQUEST_QUOTE_DATES, RECEIVE_QUOTE_DATES} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function quotesReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_QUOTES:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_QUOTES:
      return objectAssign({}, state, {
        quotes: action.quotes,
        isFetching: false
      });

    case REQUEST_QUOTE_DATES:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_QUOTE_DATES:
      return objectAssign({}, state, {
        quoteDates: action.dates,
        isFetching: false
      });

    default:
      return state;
  }
}
